module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"articleDescriptionGenerated":"Article description generated","description":"Description","generateDescription":"Generate description","recommendedDescriptionLength":"{0} out of 160 max recommended characters"}}')
  delete Component.options._Ctor
}
